import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as WorkbookDownstreamOwnersQuery
export const WorkbookDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query WorkbookDownstreamOwnerIdsQuery($WorkbookVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  workbooks(filter: { vizportalUrlId: $WorkbookVizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
